import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BellPlus, BellRing, Loader2 } from "lucide-react";
import { api, errText } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { useLanguage } from "../../context/LanguageContext";
import { Button } from "../ui/button";

export function FollowBreederButton({ breederId, mine, onChange }) {
  const { user, setAuthOpen } = useAuth();
  const { t } = useLanguage();
  const [state, setState] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get(`/breeders/${breederId}/follow`).then((r) => setState(r.data)).catch(() => {});
  }, [breederId, user?.user_id]);
  if (!state) return null;
  const n = state.followers;
  const count = <span className="text-xs text-slate-500" data-testid="breeder-followers-count">{n} {t(n === 1 ? "lt_follower" : "lt_followers")}</span>;
  if (mine) return count;
  const toggle = async () => {
    if (!user) return setAuthOpen(true);
    setBusy(true);
    try {
      const { data } = state.following ? await api.delete(`/breeders/${breederId}/follow`) : await api.post(`/breeders/${breederId}/follow`);
      setState(data);
      onChange?.(data);
      toast.success(t(data.following ? "lt_follow_toast" : "lt_unfollow_toast"));
    } catch (e) { toast.error(errText(e)); }
    finally { setBusy(false); }
  };
  return (
    <div className="flex items-center gap-3">
      <Button onClick={toggle} disabled={busy} variant={state.following ? "outline" : "default"} data-testid="follow-breeder-btn"
        title={state.following ? t("lt_unfollow") : undefined}
        className={`rounded-full h-9 gap-1.5 ${state.following ? "border-purple-300 text-purple-700 hover:bg-purple-50" : "bg-purple-600 hover:bg-purple-700 text-white"}`}>
        {busy ? <Loader2 size={15} className="animate-spin" /> : state.following ? <BellRing size={15} /> : <BellPlus size={15} />}
        {t(state.following ? "lt_following" : "lt_follow")}
      </Button>
      {count}
    </div>
  );
}
